<template>
  <div>
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="onSave">{{locale.save}}</button>
    </div>
    <div class="innerItem">
      <span class="checkbox">
        <input type="checkbox" id="use_flightinfo" v-model="use" />
        <label for="use_flightinfo">사용</label>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale'
  ],
  computed: {
    airportSetting () {
      return this.$store.state.flightinfo.setting
    },
    use: {
      get () {
        return this.airportSetting.use
      },
      set (data) {
        this.$store.commit('flightinfo/setUse', data)
      }
    }
  },
  methods: {
    validateOnSave () {
      return true
    },
    onSave () {
      const isPassed = this.validateOnSave()
      const airportSetting = this.airportSetting
      if (isPassed) {
        this.$store.commit('onLoading', true)
        this.$store.dispatch('flightinfo/setAirportDisplay').then(() => {
          this.$store.dispatch('flightinfo/setAirportSetting', airportSetting).then((res) => {
            alert(this.locale.complete_save)
            this.$store.dispatch('flightinfo/setAirportSettingData').then(() => {
              this.$store.commit('onLoading', false)
            })
          })
        })
      }
    }
  }
}
</script>
